import React from 'react';
import { useTranslation } from 'react-i18next';

const LabFooter: React.FC = () => {
  const { t } = useTranslation();

  return (
    <footer className="relative z-10 border-t border-white/10 bg-lab-night/40 px-6 py-[30px] backdrop-blur-lg md:px-14">
      <div className="mx-auto flex w-full max-w-[1360px] flex-col items-center gap-4 text-[13px] text-lab-frost/60 md:flex-row md:justify-between">
        <div className="text-center md:text-start">
          <span className="font-semibold text-lab-frost">duran</span> — {t('lab.footer.tagline')}
        </div>
        <span className="font-plexmono text-[11px]">© {new Date().getFullYear()} DURAN</span>
      </div>
    </footer>
  );
};

export default LabFooter;
